<template>
  <div id="app">
    <navigeation v-if="!hideLayout" ref="navigeation" @changePanel="changePanel"/>
    <!-- <keep-alive exclude="imageGeneration,videoGeneration,businessMaintenance,fieldSetInfo,followManage,pool,detailsInfo,contacts,contactDetails,addContent"> -->
    <keep-alive :include="include">
      <router-view ref="routerView" @openLogin="openLogin" />
    </keep-alive>
    <!-- <Footers v-if="!logged"  />  -->
    <Bottom v-if="!logged && !hideLayout"  />
  </div>
</template>

<script>
import home from '@/views/home.vue'
import navigeation from "./components/navigation.vue";
import Footers from './views/homePage/footers.vue';
import Bottom from '@/views/v2/components/bottom.vue';
import Cookies from 'js-cookie'

export default {
  name: 'App',
  components: {
    navigeation,
    home,
    Footers,
    Bottom,
  },
  data() {
    return {
      include: 'advancedSearch,guessYouLike,similarRecommend',
      logged: false,
      hideLayout: false
    }
  },
  created() {
    this.logged = !!Cookies.get("userId");
    this.hideLayout = !!this.$route.meta.hideLayout;
    this._toggleBaiduIM(!this.$route.meta.hideLayout);
    // ?login=1 自动弹登录窗（从新 Nuxt 营销页跳来时触发，任何路由都生效）
    if (this.$route.query && this.$route.query.login === '1') {
      this.$nextTick(() => {
        if (this.$refs.navigeation) {
          this.$refs.navigeation.handleOpen()
        }
      })
    }
  },
  watch: {
    $route(to) {
      this.hideLayout = !!to.meta.hideLayout;
      this._toggleBaiduIM(!to.meta.hideLayout);
    }
  },
  methods: {
    // 打开登录
    openLogin() {
      // console.log(this.$refs.navigeation);
      if(this.$refs.navigeation != null) {
        this.$refs.navigeation.handleOpen()
      }
    },
    changePanel(panel) {
      if(this.$refs.routerView) this.$refs.routerView.changePanel(panel)
    }
  }

}
</script>

<style>
#app {
  font-family: 'MiSans-Regular';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 滚动条整体样式 */
::-webkit-scrollbar {
  width: 8px;  /*  高宽分别对应横竖滚动条的尺寸 */
  height: 5px;
}
/* 滚动条里面小方块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #E5E5E5;
}
/* 滚动条里面轨道 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ffffff;
}
/* 滚动条上下的箭头按钮 */
::-webkit-scrollbar-button {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue